import { render, staticRenderFns } from "./Notificatiions.vue?vue&type=template&id=7ec65364"
import script from "./Notificatiions.vue?vue&type=script&lang=js"
export * from "./Notificatiions.vue?vue&type=script&lang=js"
import style0 from "./Notificatiions.vue?vue&type=style&index=0&id=7ec65364&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports